import type { Route } from '#/global'
import type { RouteRecordRaw } from 'vue-router'
import generatedRoutes from 'virtual:generated-pages'
import { setupLayouts } from 'virtual:meta-layouts'
import { $t } from '@/locales'
import pinia from '@/store'
import { useSettingsStore } from '@/store/modules/settings'
import ControlCenterRoutes from './modules/control-center'
import CraeAiEmployeeRoutes, { newAiEmployeeRoutes } from './modules/crae-ai-employee'
import CustomerRoutes from './modules/customer'
import LibraryRoutes from './modules/library'
import OrganizationRoutes from './modules/organization'
import ProjectRoutes from './modules/project'
import RulesDocumentsRoutes from './modules/rules-documents'
import SettingsRoutes from './modules/settings'
import WecomRoutes from './modules/wecom'

// 固定路由（默认路由）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      whiteList: true,
      title: $t('app.route.login'),
    },
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: '找不到页面',
    },
  },
]

// 系统路由
const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    meta: {
      breadcrumb: false,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/index.vue'),
        meta: {
          title: $t(useSettingsStore(pinia).settings.home.title),
          icon: 'i-ant-design:home-twotone',
          breadcrumb: false,
        },
      },
      {
        path: 'reload',
        name: 'reload',
        component: () => import('@/views/reload.vue'),
        meta: {
          title: $t('app.route.reload'),
          breadcrumb: false,
        },
      },
    ],
  },
]

// 动态路由（异步路由、导航栏路由）
const asyncRoutes: Route.recordMainRaw[] = [
  {
    meta: {
      title: '组织',
      icon: 'i-ant-design:team-outlined',
    },
    children: [
      OrganizationRoutes,
      CustomerRoutes,
      WecomRoutes,
    ],
  },
  {
    meta: {
      title: '资料',
      icon: 'i-ant-design:folder-open-outlined',
    },
    children: [
      LibraryRoutes,
      RulesDocumentsRoutes,
    ],
  },
  {
    meta: {
      title: '研发',
      icon: 'i-ant-design:project-outlined',
    },
    children: [
      ProjectRoutes,
    ],
  },
  {
    meta: {
      title: '中控',
      icon: 'i-ant-design:appstore-outlined',
    },
    children: [
      ControlCenterRoutes,
    ],
  },
  {
    meta: {
      title: 'AI',
      icon: 'i-ant-design:usergroup-add-outlined',
    },
    children: [
      CraeAiEmployeeRoutes,
    ],
  },
  {
    meta: {
      title: '新AI员工',
      icon: 'i-ant-design:usergroup-add-outlined',
    },
    children: [newAiEmployeeRoutes],
  },
  {
    meta: {
      title: '设置',
      icon: 'i-ant-design:setting-outlined',
    },
    children: [
      SettingsRoutes,
    ],
  },
]

const constantRoutesByFilesystem = generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant === true
})

const asyncRoutesByFilesystem = setupLayouts(generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant !== true && item.meta?.layout !== false
}))

export {
  asyncRoutes,
  asyncRoutesByFilesystem,
  constantRoutes,
  constantRoutesByFilesystem,
  systemRoutes,
}
